"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = Alert;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Alert_style_1 = require("./Alert.style");
function Alert(props) {
    return (0, jsx_runtime_1.jsx)(Alert_style_1.Alert, { ...props });
}
